import * as Highcharts from "highcharts";
import { Paleta } from "../../../../styles/theme/paletaCores";

const temaDoEixo = (paleta: Paleta) => ({
  labels: { style: { color: paleta.suave } },
  title: { style: { color: paleta.suave } },
  lineColor: paleta.borda,
  tickColor: paleta.borda,
  gridLineColor: paleta.gradeGrafico
});

export const aplicaTemaGrafico = (
  opcoes: Highcharts.Options,
  paleta: Paleta
): Highcharts.Options =>
  Highcharts.merge(
    {
      chart: { backgroundColor: paleta.fundoCartao },
      title: { style: { color: paleta.navy } },
      subtitle: { style: { color: paleta.suave } },
      xAxis: temaDoEixo(paleta),
      yAxis: temaDoEixo(paleta),
      legend: {
        itemStyle: { color: paleta.navy },
        itemHoverStyle: { color: paleta.azul }
      },
      tooltip: {
        backgroundColor: paleta.fundoCartao,
        borderColor: paleta.borda,
        style: { color: paleta.navy }
      },
      plotOptions: {
        series: {
          dataLabels: { style: { color: paleta.navy, textOutline: "none" } }
        }
      }
    },
    opcoes
  );
